import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import { ControlledTextField } from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const KidsPlanImportForm = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.settings.kidsPlan.fields'
  });

  const methods = useForm({
    // defaultValues: schema(t).cast(rowData),
    // resolver: yupResolver(schema(t))
  });

  const { handleSubmit, control } = methods;

  const onSubmit = () => {
    // mutate(data);
    // handleClose();
  };

  return (
    <MultiStepForm onSubmit={handleSubmit(onSubmit)} methods={methods}>
      <MultiStepForm.Section
        title={t('importSetting', {
          keyPrefix: 'adminPortal.settings.kidsPlan'
        })}
      >
        <ControlledTextField
          control={control}
          name="username"
          label={t(`username`)}
          fullWidth
        />

        <ControlledTextField
          control={control}
          name="host"
          label={t(`host`)}
          fullWidth
        />

        <ControlledTextField
          control={control}
          name="apiPrefix"
          label={t(`apiPrefix`)}
          fullWidth
        />

        <ControlledTextField
          control={control}
          name="clientId"
          label={t(`clientId`)}
          fullWidth
        />

        <ControlledTextField
          control={control}
          name="apiKey"
          label={t(`apiKey`)}
          fullWidth
        />
      </MultiStepForm.Section>
      <MultiStepForm.Actions>
        <Box display="flex" ml="auto">
          <LoadingButton
            // loading={isLoading}
            type="submit"
            variant="contained"
            autoFocus
            color="primary"
          >
            {t('save', {
              keyPrefix: ''
            })}
          </LoadingButton>
        </Box>
      </MultiStepForm.Actions>
    </MultiStepForm>
  );
};

export default KidsPlanImportForm;
